export default "/static/assets/customer_fit.55052c990fa27a77aa7180e76fbbdc6f.png";